var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0225 16.0245L15.9895 24.0225C14.9189 25.0678 13.479 25.6482 11.9827 25.6376C10.4865 25.6271 9.05494 25.0263 7.99923 23.966C6.94352 22.9057 6.34902 21.4715 6.34495 19.9752C6.34088 18.479 6.92757 17.0416 7.9775 15.9755L16.0105 7.97755C17.0811 6.93228 18.521 6.35186 20.0173 6.36245C21.5135 6.37304 22.9451 6.97379 24.0008 8.03411C25.0565 9.09443 25.651 10.5286 25.655 12.0249C25.6591 13.5211 25.0724 14.9585 24.0225 16.0245ZM22.6225 9.40655C21.9341 8.71614 20.9999 8.3271 20.025 8.32485C19.05 8.3226 18.114 8.70732 17.4225 9.39455L9.3885 17.3925C8.69721 18.0808 8.30764 19.0154 8.30548 19.9909C8.30332 20.9664 8.68876 21.9028 9.377 22.594C10.0652 23.2853 10.9999 23.6749 11.9754 23.6771C12.9508 23.6792 13.8872 23.2938 14.5785 22.6055L22.6115 14.6075C23.3022 13.9191 23.6914 12.9847 23.6937 12.0095C23.6959 11.0343 23.311 10.0981 22.6235 9.40655H22.6225Z",
    fill: "#155DFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2675 12.2486C12.455 12.0611 12.7093 11.9558 12.9745 11.9558C13.2397 11.9558 13.494 12.0611 13.6815 12.2486L19.7315 18.2986C19.9137 18.4872 20.0144 18.7398 20.0122 19.002C20.0099 19.2642 19.9047 19.515 19.7193 19.7004C19.5339 19.8858 19.2831 19.991 19.0209 19.9933C18.7587 19.9956 18.5061 19.8948 18.3175 19.7126L12.2675 13.6626C12.08 13.4751 11.9747 13.2208 11.9747 12.9556C11.9747 12.6904 12.08 12.4361 12.2675 12.2486Z",
    fill: "#155DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/Medication.f008a7f40657bebaf72615f3e9820a91.svg";
export { ForwardRef as ReactComponent };